import React, { Component } from 'react'

class Module1 extends Component{
    constructor(props){
        super(props)
        
    }
    render(){
        return(
            <section className="section-wrap page1">
                <div className="block column1">
                    <div className="block-head"></div>
                    <div className="block-body">
                        <div className="block-left">
                            <h1 className="block-title">{this.props.title}</h1>
                            <p className="slogan">{this.props.slogan}</p>
                        </div>
                        <div className="block-right">
                            <img width="495" src={this.props.src} />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Module1;
